import { render, staticRenderFns } from "./DoctorScheduleCalendar.vue?vue&type=template&id=8b71c6fe&scoped=true"
import script from "./DoctorScheduleCalendar.vue?vue&type=script&lang=js"
export * from "./DoctorScheduleCalendar.vue?vue&type=script&lang=js"
import style0 from "./DoctorScheduleCalendar.vue?vue&type=style&index=0&id=8b71c6fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b71c6fe",
  null
  
)

export default component.exports